export const CREATE_PERSONAL_INFO_REQUEST = 'CREATE_PERSONAL_INFO_REQUEST';
export const CREATE_PERSONAL_INFO_SUCCESS = 'CREATE_PERSONAL_INFO_SUCCESS';
export const CREATE_PERSONAL_INFO_FAILURE = 'CREATE_PERSONAL_INFO_FAILURE';

export const userTypes = {
  CANDIDATE: 'CANDIDATE',
  RECRUITER: 'RECRUITER'
};
